import React from 'react';
import { useTranslation } from 'react-i18next';
import TitleWithLanterns from '../components/TitleWithLanterns';
import LocationInfo from '../components/LocationInfo';

const Location: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="relative h-[40vh] flex items-center justify-center overflow-hidden bg-luxury-black">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-40"
          style={{
            backgroundImage: `url('/restaurant_photos/nouseretrouver_photo.png')`,
          }}
        />
        <div className="absolute inset-0 bg-luxury-gradient" />
        <TitleWithLanterns
          title={t('location.title')}
          lanternType={3}
        />
      </section>

      <LocationInfo />
    </div>
  );
};

export default Location;
